import entring from './entring'
import template from './template'
import result from './result'
import master from './master';
import masterByRole from './masterByRole';
import check from './check'
import assignOrg from './assignOrg'
import assignCheck from './assignCheck'
import orgTree from './orgTree'
import assignCheckMaster from './assignCheckMaster'
import majorFeedBack from './majorFeedBack'
import masterResult from './masterresult'
import newMasterResult from './newmasterresult'
// import statisticsByExperts from './statisticsByExperts'
// import statisticsByOrg from './statisticsByOrg'
import analysis from './analysis'
import employeeResult from './employeeResult';
import legislation from './legislation';
import templateEntring from './templateEntring';
import legislationSelf from './legislationSelf';
import employeeGuide from './employeeGuide';
import majorEvalResult from './majorEvalResult';
import courseResult from './courseResult';
import courseResult2 from './courseResult2';
import assignCheckCourseMaster from './assignCheckCourseMaster'
import assignCheckCourse from './assignCheckCourse'
import courseMasterResult from './courseMasterResult';
import roleAuth from './roleAuth';
import employee from './employee';
import courseResultStatistics from './courseResultStatistics'
import courseresultDetail from './courseresultDetail';
import resultAssign from './resultAssign';
import courseresultZyAudit from './courseresultZyAudit';
import courseresultXbAudit from './courseresultXbAudit';
import analysisCourse from './analysisCourse';
import signup from './signup';
import fileDownload from './fileDownload';
import formTemplate from './form/template.js';
import formResult from './form/result';
import formAudit1 from './form/audit1';
import formAudit2 from './form/audit2';
import formAudit3 from './form/audit3';
import formAssign from './form/assign';
import resultImport from './resultImport.js';

export default {
    entring,
    template,
    result,
    master,
    masterByRole,
    check,
    assignOrg,
    assignCheck,
    orgTree,
    assignCheckMaster,
    majorFeedBack,
    masterResult,
    newMasterResult,
    // statisticsByExperts ,
    // statisticsByOrg ,
    analysis,
    employeeResult,
    legislation,
    templateEntring,
    legislationSelf,
    employeeGuide,
    majorEvalResult,
    courseResult,
    courseResult2,
    assignCheckCourseMaster,
    assignCheckCourse,
    courseMasterResult,
    roleAuth,
    employee,
    courseResultStatistics,
    courseresultDetail,
    resultAssign,
    courseresultZyAudit,
    courseresultXbAudit,
    analysisCourse,
    signup,
    fileDownload,
    formTemplate,
    formResult,
    formAudit1,
    formAudit2,
    formAudit3,
    formAssign,
    resultImport
}